











import { Prop, Component, Vue } from "vue-property-decorator";

@Component
export default class VGrid extends Vue {
  @Prop({ default: 1 }) cols!: number;

  get style() {
    return {
      gridTemplateColumns: `repeat(${this.cols}, 1fr)`
    };
  }
}
